import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const CHEditPlanfieldField = ({ record = {} }) => <a style={styles.links} target="_blank" title='Bewerken' href={`/#/admin/planfield/${record.id}?cloudhintsdomains_id=${window.location.href.substring(window.location.href.lastIndexOf('\/')+1)}`}>Wijzigen</a>;

CHEditPlanfieldField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CHEditPlanfieldField;


// WEBPACK FOOTER //
// ./src/utils/CHEditPlanfieldField.js